import React from 'react';

interface PageProps {
  children: React.ReactNode;
}

export default function Page({ children }: PageProps) {
  return (
    <div className="relative w-full max-w-7xl mx-auto px-4 md:px-8 z-10" style={{ paddingTop: 'var(--nav-height)' }}>
      {children}
    </div>
  );
}
